import {Component, OnDestroy, OnInit, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import {Subject} from 'rxjs';
import {ErrorModalData} from '@shared/dialogs/error-modal/error-modal.data';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.css'],
    standalone: false
})
export class ErrorModalComponent implements OnInit, OnDestroy {
    acceptClose: Subject<boolean> = new Subject();

    constructor(public dialogRef: MatDialogRef<ErrorModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ErrorModalData) {}

    ngOnInit() {
    }

    ngOnDestroy() {
        this.acceptClose.next(true);
    }

    close() {
        this.dialogRef.close();
    }

}
